"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingIndicator = void 0;
var loading_indicator_styles_1 = require("./loading-indicator.styles");
Object.defineProperty(exports, "LoadingIndicator", { enumerable: true, get: function () { return loading_indicator_styles_1.StyledLoadingIndicator; } });
